import React from 'react';
import './App.css';
import SelectModes from './SelectModes'

function App() {
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <SelectModes />
    </div>
  );
}

export default App;
